// src/reducers/componentStockReducer.js

import {
  ADD_COMPONENT_STOCK_REQUEST,
  ADD_COMPONENT_STOCK_SUCCESS,
  ADD_COMPONENT_STOCK_FAIL,
  GET_ALL_COMPONENT_STOCK_REQUEST,
  GET_ALL_COMPONENT_STOCK_SUCCESS,
  GET_ALL_COMPONENT_STOCK_FAIL,
  UPDATE_COMPONENT_STOCK_REQUEST,
  UPDATE_COMPONENT_STOCK_SUCCESS,
  UPDATE_COMPONENT_STOCK_FAIL,
  DELETE_COMPONENT_STOCK_REQUEST,
  DELETE_COMPONENT_STOCK_SUCCESS,
  DELETE_COMPONENT_STOCK_FAIL,
  CLEAR_PRODUCT_ERRORS,
  CLEAR_PRODUCT_MESSAGES,
} from "../constants/productConstants";

const initialState = {
  components: [],
  loading: false,
  componentError: null,
  componentMessage: null,
};

export const componentStockReducer = (state = initialState, action) => {
  switch (action.type) {
    // --- ADD COMPONENT ---
    case ADD_COMPONENT_STOCK_REQUEST:
      return {
        ...state,
        loading: true,
        componentError: null,
        componentMessage: null,
      };
    case ADD_COMPONENT_STOCK_SUCCESS: {
      const newComponent =
        action.payload?.component ||
        (Array.isArray(action.payload) ? action.payload[0] : action.payload);

      // Accept either { component, message } or just { message }
      return {
        ...state,
        loading: false,
        components: newComponent
          ? [...state.components, newComponent]
          : state.components,
        componentMessage:
          action.payload?.message ||
          (typeof action.payload === "string"
            ? action.payload
            : "Component stock added successfully!"),
        componentError: null,
      };
    }
    case ADD_COMPONENT_STOCK_FAIL:
      return {
        ...state,
        loading: false,
        componentError: action.payload || "Could not add component stock.",
      };

    // --- GET ALL COMPONENTS ---
    case GET_ALL_COMPONENT_STOCK_REQUEST:
      return {
        ...state,
        loading: true,
        componentError: null,
        componentMessage: null,
      };
    case GET_ALL_COMPONENT_STOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        components: Array.isArray(action.payload?.components)
          ? action.payload.components
          : [],
        componentMessage: action.payload?.message || "",
        componentError: null,
      };
    case GET_ALL_COMPONENT_STOCK_FAIL:
      return {
        ...state,
        loading: false,
        componentError: action.payload || "Could not fetch components.",
      };

    // --- UPDATE COMPONENT ---
    case UPDATE_COMPONENT_STOCK_REQUEST:
      return {
        ...state,
        loading: true,
        componentError: null,
        componentMessage: null,
      };
    case UPDATE_COMPONENT_STOCK_SUCCESS: {
      const updatedComponent =
        action.payload?.component ||
        (Array.isArray(action.payload) ? action.payload[0] : action.payload);

      return {
        ...state,
        loading: false,
        components: updatedComponent
          ? state.components.map((comp) =>
              comp._id === updatedComponent._id ? updatedComponent : comp
            )
          : state.components,
        componentMessage:
          action.payload?.message ||
          (typeof action.payload === "string"
            ? action.payload
            : "Component stock updated successfully!"),
        componentError: null,
      };
    }
    case UPDATE_COMPONENT_STOCK_FAIL:
      return {
        ...state,
        loading: false,
        componentError: action.payload || "Could not update component stock.",
      };

    // --- DELETE COMPONENT ---
    case DELETE_COMPONENT_STOCK_REQUEST:
      return {
        ...state,
        loading: true,
        componentError: null,
        componentMessage: null,
      };
    case DELETE_COMPONENT_STOCK_SUCCESS: {
      const deleteId = action.payload?.id || action.payload?._id;
      return {
        ...state,
        loading: false,
        components: deleteId
          ? state.components.filter((comp) => comp._id !== deleteId)
          : state.components,
        componentMessage:
          action.payload?.message ||
          (typeof action.payload === "string"
            ? action.payload
            : "Component stock deleted successfully!"),
        componentError: null,
      };
    }
    case DELETE_COMPONENT_STOCK_FAIL:
      return {
        ...state,
        loading: false,
        componentError: action.payload || "Could not delete component stock.",
      };

    // --- CLEAR ERRORS & MESSAGES ---
    case CLEAR_PRODUCT_ERRORS:
      return { ...state, componentError: null };
    case CLEAR_PRODUCT_MESSAGES:
      return { ...state, componentMessage: null };

    // --- DEFAULT ---
    default:
      return state;
  }
};
